export const VISIBLE_LIVING_PERSON_IDS = new Set([
    'I43',
    'I3',
    'I42',
]);

export const VISIBLE_LIVING_PERSON_NAMES = new Set([
    'jeffrey thumann',
    'rudy thumann',
    'hendrikje van het ende',
]);

export function getAuthTokenValue(authToken) {
    return authToken && typeof authToken === 'object' && 'value' in authToken
        ? authToken.value
        : authToken;
}

export function hasLivingPersonAccess(authToken) {
    return Boolean(getAuthTokenValue(authToken));
}

export function isLivingPerson(person) {
    return person === true
        || person === 1
        || person === '1'
        || person?.living === true
        || Number(person?.living) === 1;
}

export function isLivingPlaceholder(person) {
    return Boolean(person?.placeholder && person?.privacyStatus === 'living');
}

export function getPersonNodeKey(person, fallback = '') {
    return person?.personID || person?.nodeID || fallback;
}

export function normalizePrivacyName(value) {
    return (value || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
}

export function isVisibleLivingPersonException(person) {
    if (!person) return false;

    if (person.personID && VISIBLE_LIVING_PERSON_IDS.has(person.personID)) {
        return true;
    }

    const fullName = [person.firstname, person.lastname].filter(Boolean).join(' ').trim();
    const normalizedFullName = normalizePrivacyName(fullName);
    const normalizedLabel = normalizePrivacyName(person.label || person.name);

    return VISIBLE_LIVING_PERSON_NAMES.has(normalizedFullName)
        || VISIBLE_LIVING_PERSON_NAMES.has(normalizedLabel);
}

export function isPrivateLivingPerson(person, authToken, options = {}) {
    const allowVisibleExceptions = options.allowVisibleExceptions !== false;

    return !isLivingPlaceholder(person)
        && isLivingPerson(person)
        && !hasLivingPersonAccess(authToken)
        && (!allowVisibleExceptions || !isVisibleLivingPersonException(person));
}

export function getLivingPersonHref(person, authToken, href, loginHref = '/login', options = {}) {
    return isPrivateLivingPerson(person, authToken, options) ? loginHref : href;
}
